/**
 * 因为animal和slide有从属关系，理论上二者应该有依赖性，所以使用useReducer可能会更理想
 * @param {obj} state slide: xxx, animal: xxx
 * @param {string} action 
 * @returns new state
 */
export default function viewerReducer(state, action) {
  switch (action.type) {
    case 'animalInfoLoaded':
      return {
        ...state,
        animalInfo: action.value?.animalInfo
      }
    case 'changeAll':
      return action.value
    case 'changeSlideId':
      const slideId = action.value?.id
      if (!slideId) {
        console.error(action)
        throw new Error("No id in action.value")
      }
      return {
        ...state,
        slideId,
      }
    default:
      throw new Error(`Unknown action.type: ${action.type}`)
  }
}